import { catalogoApi } from '@/modules/shared/lib/axios-catalogo'
import { api } from '@/modules/shared/lib/axios'
import { env } from '@/modules/shared/infra/env'

export type ClienteCatalogo = {
  id?: string
  empresaId: number
  clienteCnpj: string
  clienteId?: number
  clienteNome?: string
  clienteEmail?: string
  clienteFone?: string
  vendedorId?: number
  vendedorJwt?: string
  tabelaPrecoId?: number
  vigenciaId?: number
  token?: string
  dataCriacao?: string
  dataExpiracao?: string
  ativo?: boolean
}

export type CatalogoTokenResponse = {
  mensagem: string
  token?: ClienteCatalogo
  dados?: ClienteCatalogo
}

export type CreateTokenRequest = {
  empresaId: number
  clienteCnpj: string
  clienteId: number
  clienteNome: string
  clienteEmail: string
  clienteFone: string
  vendedorId: number
  vendedorJwt: string
  tabelaPrecoId: string
  vigenciaId: string
}

export type GetTokenRequest = {
  token: string
}

export type InvalidateTokenRequest = {
  token: string
}

export type ValidateTokenRequest = {
  empresaId: number
  clienteId: number
  vendedorId: number
  jwtPart: string
}

export type ValidateTokenResponse = {
  mensagem: string
  valido: boolean
  token?: string
  dados?: ClienteCatalogo
}

export type GenerateJwtTokenRequest = {
  DataExpiracao: string
}

export type GenerateJwtTokenResponse = {
  status: number
  message: string
  body: string
}

export const createCatalogoTokenService = async (
  requestData: CreateTokenRequest
): Promise<CatalogoTokenResponse> => {
  try {
    console.log('Dados sendo enviados para API:', requestData)
    const { data } = await catalogoApi.post('/api/token', requestData)
    console.log('Resposta da API:', data)
    return data
  } catch (error: any) {
    console.error('Erro ao criar token do catálogo:', error)
    console.error('Response data:', error?.response?.data)
    console.error('Response status:', error?.response?.status)
    throw error
  }
}

export const getCatalogoTokenService = async ({
  token,
}: GetTokenRequest): Promise<CatalogoTokenResponse> => {
  try {
    console.log('Validando token:', token)
    const { data } = await catalogoApi.get(`/api/token/${token}`)
    console.log('Resposta da validação:', data)
    return data
  } catch (error: any) {
    console.error('Erro ao buscar token do catálogo:', error)
    console.error('Response data:', error?.response?.data)
    console.error('Response status:', error?.response?.status)
    throw error
  }
}

export const invalidateCatalogoTokenService = async ({
  token,
}: InvalidateTokenRequest): Promise<CatalogoTokenResponse> => {
  try {
    const { data } = await catalogoApi.delete(`/api/token/${token}/invalidate`)
    return data
  } catch (error) {
    console.error('Erro ao invalidar token do catálogo:', error)
    throw error
  }
}

export const validateCatalogoTokenService = async (
  requestData: ValidateTokenRequest
): Promise<ValidateTokenResponse> => {
  try {
    console.log('Validando token existente:', requestData)
    const { data } = await catalogoApi.post('/api/token/validate', requestData)
    console.log('Resposta da validação:', data)
    return data
  } catch (error: any) {
    // Log mais suave - pode ser estado normal (cliente sem token)
    console.log('API de validação retornou:', {
      status: error?.response?.status,
      data: error?.response?.data,
      message: error?.message
    })
    throw error
  }
}

export const generateJwtTokenService = async (
  dataExpiracao: Date
): Promise<string> => {
  try {
    const requestData: GenerateJwtTokenRequest = {
      DataExpiracao: dataExpiracao.toISOString()
    }

    console.log('Gerando JWT Token com data de expiração:', requestData)
    const { data } = await api.post<GenerateJwtTokenResponse>('/token', requestData)
    console.log('Resposta da API de geração de JWT:', data)

    // Parse do body que vem como string JSON
    const bodyData = JSON.parse(data.body)
    return bodyData.Token
  } catch (error: any) {
    console.error('Erro ao gerar JWT token:', error)
    console.error('Response data:', error?.response?.data)
    console.error('Response status:', error?.response?.status)
    throw error
  }
}

export const generateCatalogoLinkFromToken = (token: string): string => {
  return `https://catalogo.cnesistemasfv.com.br/${token}`
}